import React from 'react';
import { i18n } from '@lt/localization';
import { memoize } from 'lodash';
import { MENU_ITEMS_ID } from '../../constants';
import styles from './topMenu.module.css';

export const getMenuItems = memoize(
  (isRoulette, reviewCount, hasExpiriences) => [
    ...(isRoulette
      ? []
      : [
          { id: MENU_ITEMS_ID.GALLERY, label: i18n.t('hotel.topMenu.gallery') },
        ]),
    { id: MENU_ITEMS_ID.SEARCHER, label: i18n.t('hotel.topMenu.searcher') },
    ...(isRoulette || !hasExpiriences
      ? []
      : [
          {
            id: MENU_ITEMS_ID.EXPERIENCE,
            label: i18n.t('hotel.topMenu.experience'),
          },
        ]),
    ...(isRoulette
      ? []
      : [
          {
            id: MENU_ITEMS_ID.HOTEL_FACTS,
            label: i18n.t('hotel.topMenu.facts'),
          },
        ]),
    { id: MENU_ITEMS_ID.MAP, label: i18n.t('hotel.topMenu.map') },
    ...(isRoulette
      ? []
      : [
          {
            id: MENU_ITEMS_ID.FACILITIES,
            label: i18n.t('hotel.topMenu.facilities'),
          },
          {
            id: MENU_ITEMS_ID.REVIEWS,
            label: (
              <span className={styles.label}>
                {i18n.t('hotel.topMenu.reviews')}
                {reviewCount ? <sup>{reviewCount}</sup> : null}
              </span>
            ),
          },
        ]),
  ],
);
